export default __webpack_public_path__ + "static/design-68c03cb5ea117be440f04b1bbae24240.gif";